import React, { useEffect, useState } from "react";
import {
  Typography,
  makeStyles,
  Divider,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  IconButton,
  useMediaQuery,
  useTheme,
  CircularProgress,
  Paper,
  TextField,
  MenuItem,
} from "@material-ui/core";
import { useForm, Controller, useWatch, useFieldArray } from "react-hook-form";
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import moment from "moment";
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import EventForm from "./EventForm";

import { Card, CardContent } from "../../components/Card";
import Grid from "../../components/Grid";
import Button from "../../components/Button";
import Table from "../../components/Table";
import { useAlert } from "../../components/Alert";
import CombinedTable from "../../components/CombinedTable";
import LoadingModal from "../../components/LoadingModal";

const GET_COURSES = gql`
  query courses($latest: Boolean, $pageSize: Int, $page: Int) {
    courses(latest: $latest, pageSize: $pageSize, page: $page) {
      count
      pageCount
      pastContents {
        id
        name
        dateStart
        signUpList {
          id
          numberOfPeople
          deposit
          remark
          signIn
          description
          balancePayment
          customer {
            id
            salesperson {
              id
              fullName
            }
            customerInfo {
              id
              fullName
              mobile1
            }
          }
        }
      }
      futureContents {
        id
        name
        dateStart
        signUpList {
          id
          numberOfPeople
          deposit
          remark
          signIn
          description
          balancePayment
          customer {
            id
            salesperson {
              id
              fullName
            }
            customerInfo {
              id
              fullName
              mobile1
            }
          }
        }
      }
    }
  }
`;

const SIGNUPCOURSE = gql`
  mutation signUpCourse($signUpCourseInputs: [SignUpCourseInput]!) {
    signUpCourse(signUpCourseInputs: $signUpCourseInputs)
  }
`;

export default function CourseAnnouncementTable() {
  const [open, setOpen] = useState(false);
  const [listOpen, setListOpen] = useState(false);
  const [listData, setListData] = useState();
  const [page, setPage] = useState(1);
  const [id, setId] = useState();

  const Alert = useAlert();
  const useStyles = makeStyles({
    DocumentContainerSpaceEvenly: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-evenly",
    },
    DocumentContainerCenter: {
      display: "flex",
      justifyContent: "center",
    },
  });
  const classes = useStyles();
  const { data, refetch, loading } = useQuery(GET_COURSES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      latest: false,
      pageSize: 10,
      page,
    },
    onError(error) {
      Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
    },
  });

  if (loading) {
    return (
      <Grid container justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <CardContent>
          <Grid
            container
            spacing={1}
            classes={{ root: classes.DocumentContainerCenter }}
          >
            <Typography style={{ fontSize: 30 }}> 課程時間公告</Typography>
          </Grid>
          <Grid container item justify={"flex-end"}>
            <Grid item xs={12} sm={2}>
              <Button
                size="small"
                color="primary"
                variant="contained"
                fullWidth
                onPress={() => setOpen(true)}
              >
                新增課程時間
              </Button>
              <EventForm
                open={open}
                data={{ id, type: "course" }}
                onClose={(v) => {
                  if (v === "refetch") refetch();
                  setOpen(false);
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={1}
            classes={{ root: classes.DocumentContainerSpaceEvenly }}
          >
            <Typography style={{ fontSize: 20 }}> 過去課程</Typography>
            <Divider orientation="vertical" flexItem style={{ height: 50 }} />
            <Typography style={{ fontSize: 20 }}> 未來課程</Typography>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={6}>
              <Table
                data={data?.courses.pastContents}
                header={["日期", "標題", "名單"]}
                columns={[
                  (item) => moment(item.dateStart).format("yyyy-MM-DD"),
                  "name",
                  (item) => (
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        setListOpen(true);
                        setListData(item.signUpList);
                      }}
                    >
                      <FormatListNumberedIcon />
                    </IconButton>
                  ),
                ]}
                onPress={(item) => {
                  setOpen(true);
                  setId(item.id);
                }}
              />
              <NameTable
                open={listOpen}
                data={listData}
                onClose={(v) => {
                  if (v === "refetch") refetch();
                  setListOpen(false);
                  setListData(null);
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <Table
                data={data?.courses.futureContents}
                header={["日期", "標題", "名單"]}
                columns={[
                  (item) => moment(item.dateStart).format("yyyy-MM-DD"),
                  "name",
                  (item) => (
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        setListOpen(true);
                        setListData(item.signUpList);
                      }}
                    >
                      <FormatListNumberedIcon />
                    </IconButton>
                  ),
                ]}
                onPress={(item) => {
                  setOpen(true);
                  setId(item.id);
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
}
function NameTable({ open, data, onClose = () => {} }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {
      tableData: [],
      staffData: [],
      numberOfPeople: 0,
    },
  });
  const numberOfPeople = useWatch({ control, name: "numberOfPeople" });

  const { fields: tableDataFields } = useFieldArray({
    control,
    name: "tableData",
  });

  const { fields: staffDataFields } = useFieldArray({
    control,
    name: "staffData",
  });

  const [signUpCourse, { loading: signUpCourseLoading }] = useMutation(
    SIGNUPCOURSE,
    {
      onCompleted({ signUpCourse }) {
        if (signUpCourse) onClose("refetch");
      },
    }
  );

  useEffect(() => {
    let newTableData = [];
    let newStaffData = [];
    let newNumberOfPeople = 0;
    if (data) {
      data.forEach((item) => {
        newTableData.push({
          id: item.id,
          name: item.customer?.customerInfo[0].fullName,
          phone: item.customer?.customerInfo[0].mobile1,
          quantity: item.numberOfPeople,
          deposit: item.deposit,
          balancePayment: item.balancePayment,
          business: item.customer?.salesperson?.fullName,
          remark: item.remark,
          signIn:
            typeof item.signIn === "boolean"
              ? item.signIn
                ? "已簽到"
                : "未簽到"
              : "",
          explanation: item.description,
        });

        if (
          !newStaffData.find(
            (item2) => item2.name === item.customer?.salesperson?.fullName
          )
        ) {
          newStaffData.push({
            name: item.customer?.salesperson?.fullName,
            numberOfSignUp: data.reduce((total, item2) => {
              if (
                typeof item2.signIn === "boolean" &&
                item2.signIn &&
                item2.customer?.salesperson?.fullName ===
                  item.customer?.salesperson?.fullName
              )
                total += item2.numberOfPeople;
              return total;
            }, 0),
            amountReceived: data.reduce((total, item2) => {
              if (
                typeof item2.signIn === "boolean" &&
                item2.signIn &&
                item2.customer?.salesperson?.fullName ===
                  item.customer?.salesperson?.fullName
              )
                total += Number(item.deposit) + Number(item.balancePayment);
              return total;
            }, 0),
          });
        }

        newNumberOfPeople += item.numberOfPeople;
      });
    }
    setValue("tableData", newTableData);
    setValue("staffData", newStaffData);
    setValue("numberOfPeople", newNumberOfPeople);
  }, [data]);
  function save(data) {
    let signUpCourseInputs = [];
    data.tableData.forEach((item) => {
      signUpCourseInputs.push({
        id: item.id,
        numberOfPeople: Number(item.quantity),
        deposit: Number(item.deposit),
        balancePayment: Number(item.balancePayment),
        remark: item.remark,
        signIn:
          item.signIn !== "" ? (item.signIn === "已簽到" ? true : false) : null,
        description: item.explanation,
      });
    });

    signUpCourse({ variables: { signUpCourseInputs } });
  }
  return (
    <Dialog open={open} fullScreen={fullScreen} fullWidth maxWidth={"lg"}>
      <Card>
        <LoadingModal loading={signUpCourseLoading} />
        <CardContent>
          <Grid container spacing={1} justify="center">
            <Typography style={{ fontSize: 25 }}>
              {"法拍入門實戰 學員名單"}
            </Typography>
          </Grid>
        </CardContent>
        <Divider />
        <Card>
          <CardContent>
            <div style={{ height: 300 }}>
              <CombinedTable
                data={tableDataFields ? tableDataFields : []}
                keyExtractor={(item) => item.id}
                tableContainerProps={{ component: Paper }}
                cellMinWidth="100px"
                head={{
                  children: [
                    { children: "編號" },
                    { children: "學員姓名" },
                    { children: "連絡電話" },
                    { children: "參加人數" },
                    { children: "預收訂金" },
                    { children: "應收金額" },
                    { children: "服務業務" },
                    { children: "備註事項" },
                    { children: "簽到狀態" },
                    { children: "說明事項" },
                  ],
                }}
                body={(item, index) => {
                  return {
                    children: [
                      { children: index + 1 },
                      { children: item.name },
                      { children: item.phone },
                      {
                        children: (
                          <Controller
                            render={({ field, fieldState: { error } }) => (
                              <TextField
                                style={{ maxWidth: "100px" }}
                                {...field}
                                error={error}
                                helperText={error?.message}
                              />
                            )}
                            name={`tableData.${index}.quantity`}
                            control={control}
                            rules={{
                              required: "請輸入人數",
                            }}
                          />
                        ),
                      },
                      {
                        children: (
                          <Controller
                            render={({ field, fieldState: { error } }) => (
                              <TextField
                                style={{ maxWidth: "100px" }}
                                {...field}
                                error={error}
                                helperText={error?.message}
                              />
                            )}
                            name={`tableData.${index}.deposit`}
                            control={control}
                            rules={{
                              required: "請輸入訂金",
                            }}
                          />
                        ),
                      },
                      {
                        children: (
                          <Controller
                            render={({ field, fieldState: { error } }) => (
                              <TextField
                                style={{ maxWidth: "100px" }}
                                {...field}
                                error={error}
                                helperText={error?.message}
                              />
                            )}
                            name={`tableData.${index}.balancePayment`}
                            control={control}
                          />
                        ),
                      },
                      { children: item.business },
                      {
                        children: (
                          <Controller
                            render={({ field, fieldState: { error } }) => (
                              <TextField
                                {...field}
                                error={error}
                                helperText={error?.message}
                              />
                            )}
                            name={`tableData.${index}.remark`}
                            control={control}
                          />
                        ),
                      },
                      {
                        children: (
                          <Controller
                            render={({ field, fieldState: { error } }) => (
                              <TextField
                                style={{ minWidth: "100px" }}
                                select
                                {...field}
                                error={error}
                                helperText={error?.message}
                              >
                                <MenuItem value={"已簽到"}>已簽到</MenuItem>
                                <MenuItem value={"未簽到"}>未簽到</MenuItem>
                              </TextField>
                            )}
                            name={`tableData.${index}.signIn`}
                            control={control}
                          />
                        ),
                      },
                      {
                        children: (
                          <Controller
                            render={({ field, fieldState: { error } }) => (
                              <TextField
                                {...field}
                                error={error}
                                helperText={error?.message}
                              />
                            )}
                            name={`tableData.${index}.explanation`}
                            control={control}
                          />
                        ),
                      },
                    ],
                  };
                }}
              />
            </div>
          </CardContent>
        </Card>
        <Divider />
        <CardContent>
          <Grid container spacing={1} direction="row" justify="space-evenly">
            <Typography style={{ fontSize: 20 }}>
              {`應到人數:${numberOfPeople}位`}
            </Typography>
            <Typography style={{ fontSize: 20 }}>
              {`實到人數:${tableDataFields.reduce((total, item) => {
                if (typeof item.signIn === "boolean")
                  if (item.signIn) total += item.quantity;
                return total;
              }, 0)}位`}
            </Typography>
            <Typography style={{ fontSize: 20 }}>
              {`未到人數:${tableDataFields.reduce((total, item) => {
                if (!item.signIn) total += item.quantity;
                return total;
              }, 0)}位`}
            </Typography>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Grid container spacing={1} direction="row" justify="space-evenly">
            <Typography style={{ fontSize: 20 }}>
              {`應收總計:${tableDataFields.reduce((total, item) => {
                return (
                  total + Number(item.deposit) + Number(item.balancePayment)
                );
              }, 0)}元`}
            </Typography>
            <Typography style={{ fontSize: 20 }}>
              {`預收總計:${tableDataFields.reduce((total, item) => {
                return total + Number(item.deposit);
              }, 0)}元`}
            </Typography>
            <Typography style={{ fontSize: 20 }}>
              {/* {"實收總計:" + "元"} */}
              {"實收總計:" + "如何計算"}
            </Typography>
            <Typography style={{ fontSize: 20 }}>
              {"費用總計:" + "元"}
            </Typography>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Grid container spacing={1} justify="center">
            <Typography style={{ fontSize: 20 }}>
              {staffDataFields.map((item) => {
                return `${item.name}:${item.numberOfSignUp}位[${item.amountReceived}元]，`;
              })}
            </Typography>
          </Grid>
        </CardContent>
        <Divider />
        <DialogActions>
          <Grid container spacing={1} justify="center">
            <Grid item>
              <Button variant="outlined" onPress={onClose} color="primary">
                返回
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                onPress={handleSubmit(save)}
                color="primary"
              >
                儲存
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Card>
    </Dialog>
  );
}
